// @flow
import styled from 'styled-components'
import { media } from 'src/theme/style-utils'
import { theme } from 'src/theme/globalStyle'

export const HeaderWrapper = styled.div`
  width: 100vw;
  position: fixed;
  display: flex;
  will-change: opacity;
  opacity: ${props => (props.isShown ? 1 : 0)};
  transition: opacity 0.25s ease;
  align-items: center;
   z-index:${props => (props.isShown ? 102 : -1)}
  justify-content: space-between;
  padding: 20px;
  background-color: ${theme.superlight};
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
  }
  ${media.tabletLarge`
      padding: 20px 40px;
  `}
  ${media.desktop`
    display:none;
    z-index: -1;
  `}
`
export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  color: ${theme.black};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
`
export const StyledButton = styled.button`
  border-radius: 60px;
  border: solid 1px ${theme.secondary};
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.32px;
  color: ${theme.black};
  padding: 11px 22px;
  background: transparent;
  margin: 0;
`
export const RoomName = styled.h3`
  margin: 0;
  padding: 0;
  font-family: 'RelativeBold', 'Helvetica', 'Arial', sans-serif;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 6px;
`
export const RoomInfoText = styled.p`
  margin: 0;
  padding: 0;
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.43;
  letter-spacing: 0.28px;
`



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/MobileHeader/StyledElements.js